import PersonasSettingsAndAccessForm from './PersonasSettingsAndAccessForm';
import UserSettingsAndAccessForm from './UserSettingsAndAccessForm';
import type { PermissionMap, UserSettings, UserData } from 'admin/types';

type UserSettingsAndAccessFormProps = {
  disableAll?: boolean;
  isPersonaForm?: boolean;
  userPermissions: PermissionMap | undefined;
  userSettings: UserSettings;
  setUserSettings: React.Dispatch<React.SetStateAction<UserSettings | undefined>>;
  setUserPermissions: React.Dispatch<React.SetStateAction<PermissionMap | undefined>>;
  userData?: UserData;
};

function SettingsAndAccessForm({
  disableAll = false,
  isPersonaForm = false,
  userPermissions = {},
  userSettings,
  setUserSettings,
  setUserPermissions,
  userData,
}: UserSettingsAndAccessFormProps) {
  return isPersonaForm ? (
    <PersonasSettingsAndAccessForm
      isPersonaForm={isPersonaForm}
      userSettings={userSettings}
      setUserSettings={setUserSettings}
      userData={userData}
      disableAll={disableAll}
      userPermissions={userPermissions}
      setUserPermissions={setUserPermissions}
    />
  ) : (
    <UserSettingsAndAccessForm
      userSettings={userSettings}
      setUserSettings={setUserSettings}
      userData={userData}
      disableAll={disableAll}
      userPermissions={userPermissions}
      setUserPermissions={setUserPermissions}
    />
  );
}

export default SettingsAndAccessForm;
